import React from "react";

import "./AmpButton.css";

export interface AmpButtonProps {
    onClick: React.MouseEventHandler;
    type: "cancel" | "submit";
    buttonType?:  "submit" | "button" | "reset" | undefined;
    text: string | JSX.Element;
    disabled?: boolean;
    atlStyle?: boolean;
    testId?: string;
}

const buttonClasses = {
    cancel: "button-cancel",
    submit: "button-submit"
}

export default function AmpButton(props: AmpButtonProps): JSX.Element{
    return (
        <button data-testid={props.testId} type={props.buttonType} disabled={props.disabled} className={`${buttonClasses[props.type]} ${props.atlStyle && "alt"}`} onClick={(e) => {props.onClick(e)}}>{props.text}</button>
    )
}